import type { ReactNode } from 'react';
import { createContext, useCallback, useContext, useState } from 'react';

interface PremiumDialogCtx {
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

const PremiumDialogContext = createContext<PremiumDialogCtx | null>(null);

export function PremiumDialogProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const openDialog = useCallback(() => setIsOpen(true), []);
  const closeDialog = useCallback(() => setIsOpen(false), []);
  return (
    <PremiumDialogContext.Provider value={{ isOpen, openDialog, closeDialog }}>
      {children}
    </PremiumDialogContext.Provider>
  );
}

export function usePremiumDialog(): PremiumDialogCtx {
  const ctx = useContext(PremiumDialogContext);
  if (!ctx) throw new Error('usePremiumDialog must be inside PremiumDialogProvider');
  return ctx;
}
